import React, { useState } from 'react'
import CommonTable from './CommonTable'
import Finance from './Finance';
import "./useragreement.css"
import AttorneyTable from './AttorneyTable';
import OrderRecords from './Order';

const Agreement = () => {
    const [number, setNumber] = useState(2);
    const [selectDate,setSelectDate] = useState(0)
    const [customDate,setCustomdate] = useState({startDate:'',endDate:''})

  return (
    <>
      <Finance selectDate={selectDate} setSelectDate={setSelectDate} customDate={customDate} setCustomdate={setCustomdate} />
      <div className="col-12 d-flex m-2 mt-0" style={{ paddingTop: "5px" ,borderBottom:"1px solid #474747"}} >
        {/* <button className={number == 1 ? "schedule-active me-2 schedule fw-bold  border-gray mt-0" : "me-2 schedule  fw-bold  border-gray"} onClick={() => setNumber(1)}>Service</button>  */}
        <button className={number == 2 ? "schedule-active me-2 schedule ps-0 fw-bold  border-gray mt-0" : "me-2 schedule  fw-bold  border-gray ps-0"} onClick={() => setNumber(2)}>Attorney Client</button>
        <button className={number == 3 ? "schedule-active me-2 schedule ps-0 fw-bold  border-gray mt-0" : "me-2 schedule  fw-bold  border-gray ps-0"} onClick={() => setNumber(3)}>Order Details</button>
      </div>
     {number == 1 ? <CommonTable /> : number == 2 ? <AttorneyTable selectDate={selectDate} customDate={customDate} /> : number == 3 ? <OrderRecords selectDate={selectDate} customDate={customDate} /> : ''}
    </>
  )
}

export default Agreement